import React from 'react'
import styles from './JobList.module.css'
import JobCard from './JobCard'
import Reveal from '../Reveal/Reveal'
import { JobCategory } from './types'

type JobCategorySectionProps = {
    category: JobCategory
}

export default function JobCategorySection({
    category,
}: JobCategorySectionProps) {
    // カテゴリ個別指定 → carousel(既定) の順で解決
    const resolvedVariant = category.variant ?? 'carousel'
    const jobListClassName = `${styles.jobList} ${
        resolvedVariant === 'list' ? styles.jobListVertical : ''
    }`

    return (
        <Reveal className={styles.jobCategory}>
            <div className={styles.jobCategoryHeader}>
                <p className={styles.jobCategoryLabel}>
                    <span className={styles.jobCategoryLabelLine} />
                    <span className={styles.jobCategoryLabelText}>
                        {category.categoryLabel}
                    </span>
                    <span className={styles.jobCategoryLabelLine} />
                </p>
                <p className={styles.jobCategoryDescription}>
                    {category.description}
                </p>
            </div>
            <div className={jobListClassName}>
                {category.jobs.map(job => (
                    <JobCard key={job.offerId} job={job} />
                ))}
            </div>
        </Reveal>
    )
}
